import WebHttpClient from '~src/httpClient/WebHttpClient';
import {
  IRotateSiteEncryptionKeyResult,
  RotateSiteEncryptionKeyRequest
} from '~src/kmsInOnline/serverApi/RotateSiteEncryptionKeyRequest';

export function rotateSiteEncryptionKey(): Promise<IRotateSiteEncryptionKeyResult>  {
  const isComplete = (result: IRotateSiteEncryptionKeyResult): boolean => {
    return result != null;
  };

  return WebHttpClient.sendRequest(new RotateSiteEncryptionKeyRequest({}));
}

export const RotateSiteEncryptionKeyService = {
  rotateSiteEncryptionKey: rotateSiteEncryptionKey
};